import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quileditor_New";
import DatePicker from "../../../Components/DatePicker/datePicker";
import SectionToolbar from "../../../Components/GlobalSectionToolbar/SectionToolbar";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import SectionHeader from "../SectionHeader/sectionHeader";
import SectionItemWrapper from "../SectionItemWrapper/SectionItemWrapper";
import { achievementsSvg } from "../../../masterData";

function Achievements(props) {
  const {
    resumeFields,
    sectionId,
    sectionTitleUpdate,
    handleEditorChange,
    resumeHandler,
    resumeTitleHandler,
    resumeUpdate,
    styles,
    settings,
    dateHandler,
    handleSliderChange,
    PageMargin,
    SectionMargin,
    layout,
  } = props;
  const [t, i18n] = useTranslation("common");
  const { json, setJson, jsonIndex, setJsonIndex, isJson, setIsJson } =
    useContext(jsonEditorContext);

  const editorSettings = useSelector(
    (state) => state.editorData.editorSettings
  );

  const customizationData = useSelector(
    (state) => state.editorData.customization
  );

  const [showSettings, setShowSettings] = useState(false);
  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  //UseForm

  const { showHideElements } = ResumeSubUseForm(props.sectionId);

  const innerSectionClick = (e, index) => {
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  const mainSectionClick = (e, title) => {
    props.changeFocusStyle(props.sectionId, false, "section");
  };

  const handleDatePicker = () => {
    setShowDatePicker(true);
  };

  const { selectedFont, primaryColor, secondaryColor, titleFont, bodyFont } =
    styles;
  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <SectionHeader
            styles={styles}
            settings={settings}
            resumeFields={resumeFields}
            sectionId={sectionId}
            resumeTitleHandler={resumeTitleHandler}
            resumeUpdate={resumeUpdate}
            PageMargin={PageMargin}
            SectionMargin={SectionMargin}
          />
          <div className="section-item-wrapper achievements-item-wrapper">
            {props &&
              props.response &&
              props.response.itemIndexes.map(
                (result, ind) =>
                  resumeFields &&
                  resumeFields.data &&
                  resumeFields.data.map((response, index, row) =>
                    index == result ? (
                      <SectionItemWrapper
                        sectionId={sectionId}
                        styles={styles}
                        layout={layout}
                        index={index}
                        newSectionFocus={props.newSectionFocus}
                        currentStateFocus={props.currentStateFocus}
                        newItemFocus={props.newItemFocus}
                        SectionMargin={SectionMargin}
                        onMouseDown={(e) => e.stopPropagation()}
                        isFixedPaddingBottom={true}
                        paddingBottom={"5px"}
                        onClick={(e) => {
                          e.stopPropagation();
                          innerSectionClick(e, index);
                        }}
                      >
                        {showQuillToolbar &&
                          props.newSectionFocus == props.sectionId &&
                          props.currentStateFocus == "item" &&
                          props.newItemFocus &&
                          props.newItemFocus == index.toString() && (
                            <SectionItemToolbar
                              index={index}
                              indexString={index.toString()}
                              handleDelete={props.handleItemDelete}
                              addAdditionalField={props.addAdditionalField}
                              sectionItemMoveUp={props.sectionItemMoveUp}
                              sectionItemMoveDown={props.sectionItemMoveDown}
                              row={row}
                              sectionId={props.sectionId}
                              startFrom={response.startFrom}
                              endUntil={response.endUntil}
                              resumeUpdate={resumeUpdate}
                              dateHandler={dateHandler}
                              showDatePicker={showDatePicker}
                              response={response}
                              changeSettings={props.changeSettings}
                              handleSliderChange={handleSliderChange}
                              handleAchievementSvg={props.handleAchievementSvg}
                            />
                          )}

                        {response &&
                        response.showFields &&
                        response.showFields.isSvg ? (
                          <>
                            {response &&
                            response.showFields &&
                            response.showFields.isSvg &&
                            response &&
                            response.showFields &&
                            response.showFields.name ? (
                              <>
                                <div className="d-flex">
                                  <div
                                    className="mr-2"
                                    style={{ alignSelf: "center" }}
                                  >
                                    {achievementsSvg &&
                                      achievementsSvg.map(
                                        (SvgComponent, index) =>
                                          index === response.svgImage ? (
                                            <SvgComponent
                                              key={index}
                                              color={secondaryColor}
                                            />
                                          ) : null // Renders nothing if the condition is not met
                                      )}
                                  </div>
                                  <div style={{ alignSelf: "center" }}>
                                    {response &&
                                      response.showFields &&
                                      response.showFields.name && (
                                        <div>
                                          <ContentEditable
                                            sectionId={sectionId}
                                            name="name"
                                            index={index}
                                            tagType="h5"
                                            className=""
                                            value={response.name}
                                            placeholder="Award"
                                            onChange={resumeHandler}
                                            onBlur={resumeUpdate}
                                            style={{
                                              color: primaryColor,
                                              fontFamily: bodyFont,
                                              fontSize: selectedFont?.h4,
                                              lineHeight:
                                                selectedFont?.h4_lineHeight,
                                              fontWeight: 400,
                                              textAlign: "justify",
                                            }}
                                          />
                                        </div>
                                      )}
                                    {response &&
                                      response.showFields &&
                                      response.showFields.description && (
                                        <div className="achievements-description resume-description">
                                          <Quilleditor
                                            type="visual"
                                            showQuillToolbar={showQuillToolbar}
                                            changesetShowQuillToolbar={
                                              changesetShowQuillToolbar
                                            }
                                            theme="snow"
                                            className={``}
                                            inivalue={
                                              response?.description
                                                ? response?.description?.replace(
                                                    /\n|\r/g,
                                                    ""
                                                  )
                                                : ""
                                            }
                                            current={index}
                                            setvalue={handleEditorChange}
                                            onBlur={resumeUpdate}
                                            styles={styles}
                                            sectionId={props.sectionId}
                                            placeholder="A varied education on your resume sums up the value that your learnings and background will bring to job"
                                          />
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                {achievementsSvg &&
                                  achievementsSvg.map(
                                    (SvgComponent, index) =>
                                      index === response.svgImage ? (
                                        <SvgComponent
                                          key={index}
                                          color={secondaryColor}
                                        />
                                      ) : null // Renders nothing if the condition is not met
                                  )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {" "}
                            <div className="d-flex">
                              {response &&
                                response.showFields &&
                                response.showFields.icon && (
                                  <div className="mr-2">
                                    <svg
                                      width="22"
                                      height="17"
                                      viewBox="0 0 22 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M10.8114 3.72682C11.8247 1.90902 12.3314 1.00012 13.0889 1.00012C13.8464 1.00012 14.353 1.90902 15.3663 3.72682L15.6285 4.19711C15.9164 4.71367 16.0604 4.97195 16.2849 5.14237C16.5094 5.31278 16.789 5.37604 17.3482 5.50256L17.8572 5.61774C19.825 6.06297 20.8089 6.28558 21.0429 7.03831C21.277 7.79104 20.6063 8.57538 19.2648 10.1441L18.9177 10.5499C18.5365 10.9957 18.3459 11.2186 18.2602 11.4943C18.1744 11.77 18.2032 12.0674 18.2609 12.6622L18.3133 13.2036C18.5162 15.2966 18.6176 16.3431 18.0047 16.8083C17.3919 17.2735 16.4707 16.8494 14.6283 16.0011L14.1517 15.7816C13.6281 15.5405 13.3663 15.42 13.0889 15.42C12.8114 15.42 12.5496 15.5405 12.0261 15.7816L11.5494 16.0011C9.70701 16.8494 8.78581 17.2735 8.17299 16.8083C7.56016 16.3431 7.66157 15.2966 7.86438 13.2036L7.91685 12.6622C7.97449 12.0674 8.0033 11.77 7.91756 11.4943C7.83181 11.2186 7.64121 10.9957 7.26 10.5499L6.91294 10.1441C5.57147 8.57538 4.90073 7.79104 5.1348 7.03831C5.36888 6.28558 6.35275 6.06297 8.3205 5.61774L8.82958 5.50256C9.38875 5.37604 9.66833 5.31278 9.89282 5.14237C10.1173 4.97195 10.2613 4.71367 10.5492 4.19711L10.8114 3.72682Z"
                                        fill={secondaryColor}
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M7.74536 2.20241C5.76375 1.63138 3.63808 1.933 1.58717 3.13407L1.37901 3.25598C1.02158 3.4653 0.562134 3.34523 0.352812 2.9878C0.14349 2.63037 0.263557 2.17092 0.620988 1.9616L0.829148 1.8397C3.18957 0.457369 5.7369 0.0626026 8.16071 0.76106L8.36859 0.820964C8.76661 0.935659 8.99629 1.35129 8.88159 1.74931C8.7669 2.14733 8.35126 2.37701 7.95325 2.26231L7.74536 2.20241ZM3.83616 6.93646C3.87132 7.34918 3.56525 7.71226 3.15253 7.74741C2.99937 7.76046 2.88194 7.76792 2.78353 7.77416C2.60615 7.78542 2.49057 7.79275 2.3389 7.82187C2.14241 7.85958 1.88728 7.93944 1.42428 8.17094C1.05379 8.35618 0.603288 8.20602 0.418046 7.83553C0.232804 7.46505 0.382972 7.01454 0.753456 6.8293C1.29045 6.5608 1.6802 6.42092 2.05615 6.34876C2.30305 6.30137 2.55792 6.28477 2.78712 6.26984C2.87041 6.26441 2.95031 6.25921 3.0252 6.25283C3.43792 6.21767 3.801 6.52374 3.83616 6.93646ZM4.91775 12.8561C3.7338 12.5786 2.48641 12.8538 1.55304 13.5892C1.22769 13.8456 0.756118 13.7896 0.499762 13.4643C0.243406 13.1389 0.29934 12.6674 0.624693 12.411C1.92249 11.3884 3.63899 11.0158 5.25998 11.3956C5.66327 11.4901 5.91359 11.8937 5.81909 12.297C5.72458 12.7003 5.32104 12.9506 4.91775 12.8561Z"
                                        fill={secondaryColor}
                                      />
                                    </svg>
                                  </div>
                                )}
                              <div>
                                {response &&
                                  response.showFields &&
                                  response.showFields.name && (
                                    <ContentEditable
                                      sectionId={sectionId}
                                      name="name"
                                      index={index}
                                      tagType="h5"
                                      className=""
                                      value={response.name}
                                      placeholder="Award"
                                      onChange={resumeHandler}
                                      onBlur={resumeUpdate}
                                      style={{
                                        color: primaryColor,
                                        fontFamily: bodyFont,
                                        fontSize: selectedFont?.h4,
                                        lineHeight: selectedFont?.h4_lineHeight,
                                        fontWeight: 400,
                                      }}
                                    />
                                  )}

                                {response &&
                                  response.showFields &&
                                  response.showFields.description && (
                                    <div className="achievements-description resume-description">
                                      <Quilleditor
                                        type="visual"
                                        showQuillToolbar={showQuillToolbar}
                                        changesetShowQuillToolbar={
                                          changesetShowQuillToolbar
                                        }
                                        theme="snow"
                                        className={``}
                                        inivalue={
                                          response?.description
                                            ? response?.description?.replace(
                                                /\n|\r/g,
                                                ""
                                              )
                                            : ""
                                        }
                                        current={index}
                                        setvalue={handleEditorChange}
                                        onBlur={resumeUpdate}
                                        styles={styles}
                                        sectionId={props.sectionId}
                                        placeholder="A varied education on your resume sums up the value that your learnings and background will bring to job"
                                      />
                                    </div>
                                  )}
                              </div>
                            </div>
                          </>
                        )}
                      </SectionItemWrapper>
                    ) : (
                      ""
                    )
                  )
              )}
          </div>
        </>
      )}
    </>
  );
}

export default Achievements;
